import type * as ents from '@attain-apps/entities'

import type * as models from './models'

export interface State {
  readonly finder: {
    readonly files: readonly models.File[]
    readonly filesRequest: {
      readonly error?: Error
      readonly isLoading: boolean
    }
    readonly isOpen: boolean
  }
  uploadLookup: State.UpLoadLookup
  downloadLookup: State.DownloadLookup
}

export namespace State {
  export type UpLoadLookup = Partial<
    Record<
      ents.core.common.fileManagement.Key,
      ExactlyOneOf<{
        isUploading: boolean
        error: string | Error
      }>
    >
  >

  export type DownloadLookup = Partial<
    Record<
      ents.core.common.fileManagement.Key,
      ExactlyOneOf<{
        isDownloading: boolean
        error: string | Error
      }>
    >
  >

  export const INITIAL: NoMissing<Readonly<State>> = {
    downloadLookup: {},
    finder: {
      files: [],
      filesRequest: {
        error: undefined,
        isLoading: false,
      },
      isOpen: false,
    },
    uploadLookup: {},
  }
}
